<template>
    <div>
        <div class="grid-box-sc" :style="{'height':height*2+10+'px'}">
            <div class="sp-card" id="spc">
                <div id="other1" style="width:100%;height:100%"></div>
            </div>
            <div class="sp-card">
                <div id="other2" style="width:100%;height:100%"></div>
            </div>
            <div class="sp-card">
                <div id="other3" style="width:100%;height:100%"></div>
            </div>
            <div class="sp-card">
                <div id="other4" style="width:100%;height:100%"></div>
            </div>
            <div class="sp-card">
                <div id="other5" style="width:100%;height:100%"></div>
            </div>
            <div class="sp-card">
                <div id="other6" style="width:100%;height:100%"></div>
            </div>
            <div class="sp-card">
                <div id="other7" style="width:100%;height:100%"></div>
            </div>
            <div class="sp-card">
                <div id="other8" style="width:100%;height:100%"></div>
            </div>
            <div class="sp-card">
                <div id="other9" style="width:100%;height:100%"></div>
            </div>
            <div class="sp-card">
                <div id="other10" style="width:100%;height:100%"></div>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    props:{
    },
    data(){
        return{
            chartList:[null,null,null,null,null,null,null,null,null,null],
            isShowPage:false,
            height:0,
        }
    },
    methods:{
        checkHeight:function(){
            let width = document.getElementById('spc').clientWidth;
            this.height = Math.ceil(width);
            // let scwidth = document.getElementById('scspc').clientWidth;
            // this.scheight = Math.floor(scwidth);
        },
        setResize:function(){
            this.checkHeight();
            this.chartList.forEach(e=>{
                if(e){e.resize();}
            })
        },
        init:function(){
            this.$nextTick(()=>{
                this.checkHeight();
                this.isShowPage = true;
                setTimeout(()=>{
                    this.getInfo();
                },250)
            })
        },
        close:function(){
            this.chartList.forEach(e=>{
                if(e&&(!e.isDisposed)){
                    e.dispose();
                }
            })
            this.isShowPage = false;
        },
        getMyChart:function(key){
            let myChart = this.chartList[key];
            if(!myChart){
                if(this.isShowPage){
                    myChart = echarts.init(document.getElementById('other'+(key+1)))
                    this.chartList[key] = myChart;
                }
            }else{
                myChart.clear();
            }
            return myChart;
        },
        getInfo:function(){
            this.$api.customerlistCustomer({limit:1,page:1}).then(res=>{
                let total = res.data.count;
                let myChart = this.getMyChart(0);
                if(myChart){
                    let option = this.getOption('客户数量',total);
                    myChart.setOption(option);
                }
            })
            this.$api.employeelistEmployee({limit:1,page:1}).then(res=>{
                let total = res.data.count;
                let myChart = this.getMyChart(1);
                if(myChart){
                    let option = this.getOption('职员数量',total);
                    myChart.setOption(option);
                }
            })
            this.$api.getListOrder({limit:1,page:1}).then(res=>{
                let total = res.data.count;
                let myChart = this.getMyChart(2);
                if(myChart){
                    let option = this.getOption('订单数量',total);
                    myChart.setOption(option);
                }
            })
            this.$api.listProduct({limit:1,page:1}).then(res=>{
                let total = res.data.count;
                let myChart = this.getMyChart(3);
                if(myChart){
                    let option = this.getOption('商品数量',total);
                    myChart.setOption(option);
                }
            })
            this.$api.listTransport({limit:1,page:1}).then(res=>{
                let total = res.data.count;
                let myChart = this.getMyChart(4);
                if(myChart){
                    let option = this.getOption('货运数量',total);
                    myChart.setOption(option);
                }
            })
            let today = this.$common.dayformat(new Date());
            this.$api.wxOrderStatistic({start:'1970-01-01',end:today}).then(res=>{
                let dd = res.data.data.data;
                let total1 = dd.sumSaleUnit;
                let myChart1 = this.getMyChart(5);
                if(myChart1){
                    let option = this.getOption2('商城销售数量',total1,1);
                    myChart1.setOption(option);
                }
                let total2 = dd.sumSalePrice;
                let myChart2 = this.getMyChart(6);
                if(myChart2){
                    let option = this.getOption2('商城销售金额',total2,2);
                    myChart2.setOption(option);
                }
                let total3 = dd.sumSendUnit;
                let myChart3 = this.getMyChart(7);
                if(myChart3){
                    let option = this.getOption2('商城发货数量',total3,1);
                    myChart3.setOption(option);
                }
                let total4 = dd.sumSendPrice;
                let myChart4 = this.getMyChart(8);
                if(myChart4){
                    let option = this.getOption2('商城发货金额',total4,2);
                    myChart4.setOption(option);
                }
            })
            this.$api.wxProductStatistic().then(res=>{
                let dd = res.data.data.data;
                let arr = [];
                arr.push({name:'已上架',value:dd.passCount});
                arr.push({name:'待审核',value:dd.waitPassCount});
                arr.push({name:'已下架',value:dd.notPassCount});
                let myChart = this.getMyChart(9);
                if(myChart){
                    let option = {
                        title:{
                            text:'商城商品',
                            left:'left',
                        },
                        tooltip: {
                            trigger: 'item'
                        },
                        color:[
                            '#67c23a',
                            '#f56c6c',
                            '#909399',
                        ],
                        legend: {
                            show:false,
                            orient: 'vertical',
                            left:'left',
                            bottom:'10px',
                        },
                        series: [{
                            name: 'Access From',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: 20,
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data:arr,
                        }]
                    };
                    myChart.setOption(option);
                }
            })
        },
        getOption:function(title1,total){
            let option = {
                title:{
                    text:title1,
                    left:'center',
                    top:'45%',
                },
                series: [
                    {
                        startAngle: 210,
                        endAngle: -30,
                        center: ['50%', '60%'],
                        min: 0,
                        max: total,
                        type: 'gauge',
                        splitNumber:6,
                        itemStyle:{
                            color:{
                                colorStops: [{
                                    offset: 0, color: '#A625FC' // 0% 处的颜色
                                }, {
                                    offset: 1, color: '#3AA4FA' // 100% 处的颜色
                                }],
                            },
                        },
                        progress: {
                            show: true,
                            roundCap: true,
                            width: 20,
                        },
                        axisLine: {
                            roundCap: true,
                            lineStyle: {
                                width: 20,
                            }
                        },
                        pointer:{
                            show:false,
                        },
                        axisTick:{
                            distance: -32,
                            show:true,
                        },
                        splitLine:{
                            distance: -35,
                            show: true,
                        },
                        axisLabel: {
                            show:false,
                        },
                        title: {
                            show: true,
                        },
                        detail: {
                            valueAnimation: true,
                            fontSize: 24,
                            offsetCenter: [0, '20%'],
                        },
                        data: [
                            {
                                value: total,
                            }
                        ]
                    }
                ]
            }
            return option;
        },
        getOption2:function(title,total,colors){
            let arr = [];
            if(colors==1){
                arr.push('#8E31FA');
                arr.push('#2185F0');
            }else{
                arr.push('#F8682D');
                arr.push('#FAB559');
            }
            let max = Math.ceil(total/8)*10;
                if(max<10){
                    max = 10;
                }
            let option = {
                title:{
                    text:title,
                    left:'left',
                },
                series: [
                    {
                        startAngle: 140,
                        endAngle: 40,
                        center: ['50%', '80%'],
                        min: 0,
                        max: max,
                        type: 'gauge',
                        splitNumber:3,
                        itemStyle:{
                            color:{
                                colorStops: [{
                                    offset: 0, color: arr[0] // 0% 处的颜色
                                }, {
                                    offset: 1, color: arr[1] // 100% 处的颜色
                                }],
                            },
                        },
                        progress: {
                            show: true,
                            roundCap: false,
                            width: 30,
                        },
                        axisLine: {
                            roundCap: false,
                            lineStyle: {
                                width: 30,
                            }
                        },
                        pointer:{
                            show:false,
                        },
                        axisTick:{
                            distance: -42,
                            show:true,
                        },
                        splitLine:{
                            distance: -45,
                            show: true,
                        },
                        axisLabel: {
                            show:false,
                        },
                        title: {
                            show: true,
                        },
                        detail: {
                            valueAnimation: true,
                            fontSize: 24,
                            offsetCenter: [0, '30%'],
                        },
                        data: [
                            {
                                value: total,
                            }
                        ]
                    }
                ]
            }
            return option;
        }
    }
}
</script>
<style lang="scss" scoped>
.grid-box-sc{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-gap: 10px;
    transition: .25s;
}
</style>